export enum ActionType {
    IMMEDIATE_ACTION = "forceMajor",
    USER_ACTION = "major",
    MINOR_ACTION = "minor"
};